<template>
  <v-card class="dt-modal">
    <div class="dt-modal--header"> {{$t('new_contact')}} </div>

    <div class="dt-modal--body">
      <div class="form-group">
        <TextField
          :id="'firstName'"
          required
          v-bind="textFieldConfig"
          :value="person.firstName"
          :placeholder="$t('first_name')"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        ></TextField>
        <TextField
          :id="'lastName'"
          required
          v-bind="textFieldConfig"
          :value="person.lastName"
          :placeholder="$t('last_name')"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        ></TextField>
        <TextField
          :id="'email'"
          required
          v-bind="textFieldConfig"
          :value="person.email"
          :placeholder="$t('email')"
          :validators="emailValidators"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        ></TextField>
        <TextField
          :id="'phone'"
          required
          v-bind="textFieldConfig"
          :value="person.phone"
          :placeholder="$t('phone')"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        ></TextField>
        <Dropdown
          :options="groups"
          class="group-input"
          :selected="person.groups"
          :placeholder="$t('add_to_group_optional')"
          v-on:selectedChange="e => onDropdownChange('Staff', e)"
          box
          :listHeight="95"
          multiple
          :maxSelection="3"
        ></Dropdown>
      </div>
    </div>

    <div class="dt-modal--options">
      <button
        class="dt-button v1 s1"
        :class="{'disabled': !isFormValid}"
        :disabled="!isFormValid"
        @click.stop="addNewContact"
      > {{$t('add_new_contact')}} </button>
      <button class="dt-button s1" @click.stop="onCancel"> {{$t('cancel')}} </button>
    </div>
  </v-card>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import { createValidator } from "@plugins/text-field";
import isEmail from "validator/lib/isEmail";
import Dropdown from "@plugins/dropdown/dropdown";
import DetailsTable from "../../../../plugins/datatable/datatable";
import { BookingService } from "../../services/booking-service";

export default {
  components: {
    TextField,
    Dropdown
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      person: createPerson(),
      emailValidators: [
        createValidator({
          name: "emailValidation",
          validatorFn: isEmail,
          errorMessage: "Must be a valid Email"
        })
      ],
      groups: [],
      validationResult: {},
      person: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        groups: []
      }
    };
  },
  mounted: function() {
    BookingService.findContactGroups().then(res => {
      this.groups = res.groups.map(e => ({
        text: e.group_name,
        value: e.group_id
      }));
      // console.error(this.groups);
    });
  },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    }
  },
  methods: {
    onTextFieldValueChange: function(key, value) {
      this.person[key] = value;
    },
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function(name, value) {
      this.person.groups = value;

      console.log(this.person.groups.map(e => e.value));
      this.person["group_id1"] = this.person.groups[0] && this.person.groups[0].value;
      this.person["group_id2"] = this.person.groups[1] && this.person.groups[1].value;
      this.person["group_id3"] = this.person.groups[2] && this.person.groups[2].value;
    },
    addNewContact: function(e) {
      this.$emit("new_contact", this.person);
    }
  }
};

const createPerson = ({ firstName = "", lastName = "", email = "", phone = "", group } = {}) => {
  return {
    firstName,
    lastName,
    email,
    phone,
    group
  };
};
</script>

<style lang="scss" scoped>
.form-group {
  display: flex;
  flex-direction: column;

  .dt-input-box--container {
    flex: 1;
    margin: 5px 0px;
    margin-left: 0px;
  }

  .group-input {
    margin-top: 25px;
    margin-bottom: 10px;
    margin-right: 5px;
  }
}

.dt-modal--options {
  button {
    height: 30px;
  }
}
</style>
